var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VMain',[_c('VContainer',[_c('my-business-wrapper'),_c('h2',{staticClass:"mb-5"},[_vm._v("Pending History")]),_c('pending-history')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }